import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AuthGuard = ({ element: Component }) => {
    const { isAuthenticated, role } = useAuth();


    if (isAuthenticated) {
        // Redirect based on user role
        switch (role) {
            case 'Admin':
                return <Navigate to="/Graphe/dashboard/Admin" />;
            case 'SuperAdmin':
                return <Navigate to="/Graphe/dashboard/Admin" />;
            case 'Founder':
                return <Navigate to="/Graphe/dashboard/Admin" />;
            case 'HumanResource':
                return <Navigate to="/Graphe/dashboard/Hr" />;
            case 'Accounts':
                return <Navigate to="/Graphe/dashboard/Accounts" />;
            case 'Department_Head':
                return <Navigate to="/Graphe/dashboard/employee" />;
            case 'Employee':
                return <Navigate to="/Graphe/dashboard/employee" />;
            case 'Social_Media_Manager':
                return <Navigate to="/Graphe/dashboard/employee" />;
            case 'Task_manager':
                return <Navigate to="/Graphe/dashboard/employee" />;
            case 'Ex_employee':
                return <Navigate to="/Graphe/dashboard/Ex_employee" />;
            case 'Unverified':
                return <Navigate to="/Graphe/newuser/Unverified" />;
            default:
                return <Navigate to="/Graphe/login" />;
        }
    }

    return <Component />;
};
export default AuthGuard;
